import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "fw-medium text-primary-emphasis" }
const _hoisted_10 = { class: "fw-medium text-secondary-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddModalPrepaidAccount = _resolveComponent("AddModalPrepaidAccount")!
  const _component_RechargeModal = _resolveComponent("RechargeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddModal && _ctx.openAddModal(...args)))
        }, " Ajouter un compte prépayé ")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "N° Compte"),
              _createElementVNode("th", null, "Acteur"),
              _createElementVNode("th", null, "Solde"),
              _createElementVNode("th", null, "Devise"),
              _createElementVNode("th", null, "Limite crédit"),
              _createElementVNode("th", null, "Statut"),
              _createElementVNode("th", { class: "text-end" }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("td", {
                    colspan: "7",
                    class: "text-center"
                  }, [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                    ])
                  ], -1)
                ]))]))
              : (_ctx.prepaidAccounts.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "text-center"
                    }, "Aucun compte prépayé trouvé", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.prepaidAccounts, (account) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: account.id
                    }, [
                      _createElementVNode("td", _hoisted_9, _toDisplayString(account.accountNumber), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(account.acteur?.nomComplet || 'N/A'), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["fw-bold", _ctx.getBalanceClass(account.balance)])
                      }, _toDisplayString(_ctx.formatAmount(account.balance)), 3),
                      _createElementVNode("td", null, _toDisplayString(account.currencyCode), 1),
                      _createElementVNode("td", null, _toDisplayString(account.creditLimit ? _ctx.formatAmount(account.creditLimit) : 'Aucune'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.getStatusClass(account.status)])
                        }, _toDisplayString(_ctx.getStatusLabel(account.status)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", {
                            class: "badge text-white bg-primary fs-15 dropdown-toggle",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false",
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(" Actions "),
                            _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_13, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.viewDetails(account.id))
                              }, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Voir détails ", -1)
                              ]))], 8, _hoisted_14)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.recharger(account))
                              }, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Recharger ", -1)
                              ]))], 8, _hoisted_15)
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("li", null, [
                              _createElementVNode("hr", { class: "dropdown-divider" })
                            ], -1)),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.editAccount(account.id))
                              }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ", -1)
                              ]))], 8, _hoisted_16)
                            ]),
                            (account.status === 'ACTIVE')
                              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center text-warning",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.suspendAccount(account.id))
                                  }, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "flaticon-pause lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Suspendre ", -1)
                                  ]))], 8, _hoisted_18)
                                ]))
                              : _createCommentVNode("", true),
                            (account.status === 'SUSPENDED')
                              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center text-success",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.activateAccount(account.id))
                                  }, [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "flaticon flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Activer ", -1)
                                  ]))], 8, _hoisted_20)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center text-danger",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.deleteAccount(account.id))
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Supprimer ", -1)
                              ]))], 8, _hoisted_21)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ])
    ]),
    (_ctx.showAddModal)
      ? (_openBlock(), _createBlock(_component_AddModalPrepaidAccount, {
          key: 0,
          item: _ctx.selectedAccountId,
          onClose: _ctx.handleCloseAdd,
          onOpenmodal: _ctx.openModal
        }, null, 8, ["item", "onClose", "onOpenmodal"]))
      : _createCommentVNode("", true),
    (_ctx.showRechargeModal)
      ? (_openBlock(), _createBlock(_component_RechargeModal, {
          key: 1,
          account: _ctx.selectedAccount,
          onClose: _ctx.handleCloseRecharge,
          onOpenmodal: _ctx.openRechargeModal
        }, null, 8, ["account", "onClose", "onOpenmodal"]))
      : _createCommentVNode("", true)
  ]))
}